import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ICarousel } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { FileUpload } from "primereact/fileupload";

const schema = yup.object({
    title: yup.string().required("Title is required"),
    subTitle: yup.string().required("Sub Title is required"),
});

interface Iprops {
    singleData: ICarousel,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Form = (props: Iprops) => {
    const [saveDis, setSaveDis] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [description, setDescription] = useState("");
    const [imageType, setImageType] = useState<string>("");
    const [image, setImage] = useState(false);
    const [resumeFile, setResumeFile] = useState<File | null | any>(null);
    const { control, handleSubmit, formState: { errors }, reset } = useForm<ICarousel>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);


    const saveToDB = async (data: ICarousel) => {
        const method = props.singleData.id != null ? "PUT" : "POST";
        const message = props.singleData.title != "" ? "Updated Successfully" : "Added Successfully";
        const formData = new FormData();
        formData.append('images', resumeFile);
        formData.append('coraousel', JSON.stringify(data));
        const params = {
            method: method,
            headers: {
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: formData
        };
        const response = await fetch(`${baseUrl}Carousel?typeoffile=${imageType}`, params);
        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.reloadData();
            setSaveDis(false);
        } else {
            setSaveDis(false);
        }
        setImage(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset({});
    }

    function onSubmit(data: ICarousel) {
        if (!image && (props.singleData.id === null || props.singleData.id === undefined)) {
            props.toast.current?.show({ severity: 'error', detail: "Please Upload Image First!", life: 3000 });
        } else {
            saveToDB(data);
        }
    }

    const onUpload = (event: any) => {
        const file = event.files[0];
        setImageType(event.files[0].type.split("/")[1]);
        if (event.files[0].type === "image/png" || event.files[0].type === "image/jpeg" || event.files[0].type === "image/jpg") {
            if (event.files[0].size > 1024 * 1024 * 2) {
                props.toast.current.show({ severity: 'error', content: "Image File should be less than 2 MB." });
                event.options.clear();
            } else {
                setResumeFile(file);
                setImage(true);
                event.options.clear();
            }
        } else {
            props.toast.current.show({ severity: 'error', content: "Please Choose A Image File." });
            setImage(true);
            event.options.clear();
        }

        setResumeFile(file);
        props.toast.current.show({ severity: 'success', summary: 'Success', detail: "Screenshot Saved", life: 3000 });

    };

    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '600px' }} header="Add/Edit Carousel" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput column={2} label="Title" control={control} name="title" error={errors.title?.message} />
                <JVInput column={2} label="Sub Title" control={control} name="subTitle" error={errors.subTitle?.message} />
                <div className="card flex justify-content-center">
                    <FileUpload chooseLabel="Choose Image" mode="basic" name="image" accept="image/*" customUpload uploadHandler={onUpload} auto />
                </div>
                <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-2">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}